import { ChainId, INTEGRAL_TOKEN } from '../../../../constants'
import { useApprovalForStaking, useBalance, useEthers, useNumberInput } from '../../../../hooks'
import { getCurrencyValues } from '../../../../utils'
import { StakingOption } from '../utils'

export enum StakeState {
  WALLET_NOT_CONNECTED = 'WALLET_NOT_CONNECTED',
  MISSING_INPUT = 'MISSING_INPUT',
  NEED_APPROVAL = 'NEED_APPROVAL',
  INSUFFICIENT_BALANCE = 'INSUFFICIENT_BALANCE',
  NO_ISSUE = 'NO_ISSUE',
}

export function useStake(stakingOption: StakingOption) {
  const { account, chainId = ChainId.Mainnet } = useEthers()
  const integralToken = INTEGRAL_TOKEN[chainId]
  const [stakeValue, setStakeValue] = useNumberInput(integralToken?.decimals)
  const balance = useBalance(integralToken)
  const approval = useApprovalForStaking(stakingOption, integralToken)
  const [stakeCurrencyValue] = getCurrencyValues(integralToken, stakeValue)

  function setMax() {
    if (balance) {
      setStakeValue(balance.toString())
    }
  }

  let state = StakeState.NO_ISSUE
  if (!account) {
    state = StakeState.WALLET_NOT_CONNECTED
  } else if (balance && balance.lt(stakeCurrencyValue)) {
    state = StakeState.INSUFFICIENT_BALANCE
  } else if (!stakeValue || stakeCurrencyValue.value.isZero()) {
    state = StakeState.MISSING_INPUT
  } else if (approval && approval.lt(stakeCurrencyValue)) {
    state = StakeState.NEED_APPROVAL
  }

  return { state, stakeValue, setStakeValue, setMax, integralToken }
}
